import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExternalAuthService } from './external-auth.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalAuthGuard {
  constructor(
    private externalAuthService: ExternalAuthService,
    private router: Router,
  ) {}

  canActivate(
    _route: unknown,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return (this.externalAuthService.isAuthenticated() as Observable<boolean>).pipe(
      map((authed) => {
        if (!authed) {
          return false;
        }
        const returnUrl = this.consumePostLoginReturnUrl();
        if (returnUrl && returnUrl !== state.url) {
          this.stripTokenQueryParam();
          return this.router.parseUrl(returnUrl);
        }
        return true;
      })
    );
  }

  private consumePostLoginReturnUrl(): string | null {
    try {
      const url = localStorage.getItem('postLoginReturnUrl');
      if (url) {
        localStorage.removeItem('postLoginReturnUrl');
      }
      return url;
    } catch {
      return null;
    }
  }

  private stripTokenQueryParam(): void {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('t')) {
        url.searchParams.delete('t');
        const cleaned = url.pathname + url.search + url.hash;
        window.history.replaceState({}, '', cleaned);
      }
    } catch {
      // window.history no disponible (entornos no-browser) — silenciar
    }
  }
}
